import React from 'react'
import { useTranslation } from 'react-i18next'

/**
 * SkipNavigation component for accessibility (WCAG 2.1 AA)
 * Allows keyboard users to skip repetitive navigation elements
 */
function SkipNavigation() {
  const { t } = useTranslation()

  return (
    <a
      href="#main-content"
      className="skip-link"
    >
      {t('accessibility.skipToMain', 'Skip to main content')}
    </a>
  )
}

export default SkipNavigation
